import React from 'react';
import { Link } from 'react-router-dom';

import localStorage from '../../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../../Common/Translations';
import { RoutePaths } from '../../Common/ClientRoutes';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') !== undefined ? localStorage.getFromStorage('lang') : 'en');

const SingleCompanyDetails = props => {
    return (
        <div>
            <div className="row">
                <div className="col-12 color-dark-gray">{strings.company_name}</div>
                <div className="col-12 color-light-blue mb-1 qf-big-text">{props.companyDetails.name}</div>
            </div>
            <div className="row">
                <div className="col-12 color-dark-gray">{strings.pharmacy_count}</div>
                <div className="col-12 color-light-blue mb-1 qf-big-text">{props.companyDetails.pharmaciesCount}</div>
            </div>
            <div className="row">
                <div className="col-12 color-dark-gray">{strings.address}</div>
                <div className="col-12 color-light-blue mb-1 qf-big-text">{props.companyDetails.address.name}</div>
            </div>
            <div className="row">
                <div className="col-12 color-dark-gray">{strings.phone}</div>
                <div className="col-12 color-light-blue mb-1 qf-big-text">{props.companyDetails.phone}</div>
            </div>
            {/* Email details for company goes here if it is needed */}
            <div className="row">
                <div className="col-12 color-dark-gray">{strings.owner}</div>
                <div className="col-12 color-light-blue mb-4 qf-big-text">
                    {props.companyDetails.ownerName ? props.companyDetails.ownerName : strings.no_owner_set}
                </div>
            </div>
            <div className="row">
                <div className="col-12 qf-mb-30">
                    <Link className="qf-blue-btn" to={RoutePaths.EDIT_COMPANY(props.companyDetails.id)}>
                        {strings.edit_company}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default SingleCompanyDetails;



// WEBPACK FOOTER //
// ./src/customModules/Companies/components/Company-details.js